module.exports = __webpack_public_path__ + "static/img/class-nodata.d509881e.svg";